import { getApiBaseUrl } from "./apiBase";

export async function detectRegion({ categorySlug = "", zip = "", signal } = {}) {
  const params = new URLSearchParams();

  if (categorySlug) {
    params.set("category", categorySlug);
  }

  if (zip) {
    params.set("zip", zip);
  }

  const response = await fetch(
    `${getApiBaseUrl()}/api/location/detect-region?${params.toString()}`,
    {
      method: "GET",
      signal,
      cache: "no-store",
      headers: {
        Accept: "application/json",
      },
    }
  );

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(
      data?.error || "Unable to detect your service region right now."
    );
    error.details = data || null;
    throw error;
  }

  return data;
}

export default {
  detectRegion,
};
